import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import OkModal from "components/modal/OkModal";
import SignUpModal from "../components/modal/SignUpModal";
import {Form, Input, Button, Icon, Modal, Typography, Col} from "antd";

import {
  login,
  getCurrentCustomer,
  submitPhoneNumber,
  submitOTP, generateAuthyFactor, verifyAuthyFactor
} from "api/api";
import EnterOTPLayout from "components/EnterOTPLayout";
import EnterPhoneNumberLayout from "components/EnterPhoneNumberLayout";
import { displayGenericError } from "common/notifications";
import "./LoginPage.scss";
import BrdgxIcon from "icons/BrdgxIcon";
import {displayError, displaySuccessMessage} from "../common/notifications";
import ClientTransferCalculatorSignUp from "../components/transfercalculator/ClientTransferCalculatorSignUp";
import ChangePasswordModal from "../components/settings/ChangePasswordModal";
import {validatePassword} from "../utils/utils";
import {changePasswordInFirstTime} from "../api/api";
import QRCode from "react-qr-code";
import OtpInput from "react-otp-input";

const { Text } = Typography;
const { Password } = Input;

export default class Login extends Component {
  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />;
    }
    const AntWrappedLoginForm = Form.create()(LoginForm);
    return <AntWrappedLoginForm onLogin={this.props.onLogin} />;
  }
}

class LoginForm extends Component {
  state = {
    customer: {},
    email:'',
    otpVisible: false,
    visible: false,
    signupVisible: false,
    isNoError: true,
    errorMessage:'',
    showChangePasswordModal:false,
    loginRequest:null
  };
  componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    if(params.get('message') === 'success'){
        displaySuccessMessage("Your email "+params.get('email')+ " have verified success your email!")
        this.setState({
          email: params.get('email')
        },()=>{
        })
    }
    else if(params.get('message') === 'confirmed'){
      displayError("Your email address is verified.")
      this.setState({
        email: params.get('email')
      },()=>{
      })
    }
    else if(params.get('message') === 'expired'){
      displayError("The email verification link is expired.")

    }
    if(params.get('hide-signup-modal') !== 'true'){
      this.handleOpenSignupModal();
    }
  }
  handleSubmitPhoneNumber = ({ phoneNumber, countryCode }) => {
    submitPhoneNumber(
      {
        phone: phoneNumber,
        country: countryCode,
        email:this.state.loginRequest.email,
        password:this.state.loginRequest.password,
      },
      this.token
    )
      .then(() =>
        this.setState({
          customer: {
            ...this.state.customer,
            loginStatus: "PHONE_VERIFICATION_REQUIRED",
            phone: phoneNumber
          }
        })
      )
      .catch(displayGenericError);
  };
  generateAuthyQRCode =()=>{
    generateAuthyFactor({ email:this.state.loginRequest.email,
      password:this.state.loginRequest.password }).then(response=>{
      this.setState({
        qrValue:response.content,
        qrCodeVisible: true
      })
    })
  }
  closeQRModal = ()=>{
    this.setState({
      qrCodeVisible: false
    })
  }
  verifyFactor = ()=>{
    verifyAuthyFactor({
      email: this.state.loginRequest.email,
      password: this.state.loginRequest.password,
      otp: this.state.otp
    }).then(r =>{
      if(r.result ==='success'){
        displaySuccessMessage("Verified App is ok, Please, Enter Otp code bellow");
        this.setState({
          otp: ""
        })
        localStorage.setItem("ACCESS_TOKEN", r.content);
        this.closeQRModal();
        let roleResources = this.state.customer.roleResources;
        let isReadOnly=false;
        if(roleResources && roleResources.length>0 && roleResources.find(item => item.name=="READONLY")) {
          isReadOnly = true;
        }
        getCurrentCustomer()
            .then(customer => {
              if(customer.firstLogin && customer.userType !== 'ONLINE_NF2F'){
                this.setState({
                  otpVisible: true,
                  customer,
                  showChangePasswordModal: customer.firstLogin
                });
              }else if (isReadOnly){
                window.location = "/pages/dashboard";
              }else{
                window.location = "/";
              }

            })
            .catch(displayGenericError);

      }else{
        displayError("Otp is not correct")
      }
    }).catch(error => {
      displayError(error)
    })
  }
  handleSubmitOTP = otp => {
    submitOTP(otp, null, this.token, this.state.loginRequest.email, this.state.loginRequest.password)
      .then(response => {
        if (response.result === "success") {
          let roleResources = this.state.customer.roleResources;
          let isReadOnly=false;
          if(roleResources && roleResources.length>0 && roleResources.find(item => item.name=="READONLY")) {
            isReadOnly = true;
          }

          localStorage.setItem("ACCESS_TOKEN", response.content);

          getCurrentCustomer()
              .then(customer => {
                if(customer.firstLogin && customer.userType !== 'ONLINE_NF2F'){
                  this.setState({
                    otpVisible: true,
                    customer,
                    showChangePasswordModal: customer.firstLogin
                  });
                }else if (isReadOnly){
                  window.location = "/pages/dashboard";
                }else{
                  window.location = "/";
                }

              })
              .catch(displayGenericError);
         // window.location = "/";
        } else {
          displayGenericError({ message: response.result });
        }
      })
      .catch(displayGenericError);
  };

  handleSubmit = event => {
    event.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const loginRequest = Object.assign({}, values);
        login(loginRequest)
          .then(response => {
            const token = response.accessToken;
            // save token for saving to local storage later
           // this.token = token;


            if (response.loginStatus !== "EMAIL_VERIFICATION_REQUIRED") {
              this.setState({ otpVisible: true, customer: response, loginRequest:loginRequest });
              // localStorage.setItem("ACCESS_TOKEN", this.token);
              // window.location = "/";
            } else {
              // displayGenericError({
              //   message: "Please confirm your email to login"
              // });
              this.setState({
                isNoError: false,
                errorMessage: "Please confirm your email to login"
              })
            }
            // getCurrentCustomer(token)
            //   .then(customer => {
            //     if (customer.loginStatus !== "EMAIL_VERIFICATION_REQUIRED") {
            //        this.setState({ otpVisible: true, customer });
            //       // localStorage.setItem("ACCESS_TOKEN", this.token);
            //       // window.location = "/";
            //     } else {
            //       // displayGenericError({
            //       //   message: "Please confirm your email to login"
            //       // });
            //       this.setState({
            //         isNoError:false,
            //         errorMessage:"Please confirm your email to login"
            //       })
            //     }
            //   })
            //   .catch(displayGenericError);
          })
          .catch(error => {
            if (error.status === 401) {

              // displayGenericError({
              //   message:
              //     "Your Email or Password is incorrect. Please try again!"
              // });
              this.setState({
                isNoError:false,
                errorMessage:"Your Email or Password is incorrect. Please try again!"
              })
            } else {
              this.setState({
                isNoError:false,
                errorMessage: error.result
              })
              //displayGenericError(error);
            }
          });
      }
    });
  };

  handleCloseSignupModal = () => {
    this.setState({signupVisible: false});
  };
  handleOpenSignupModal = () => {
    this.setState({signupVisible: true});
  };

  handleOk = () => {
    this.setState({
      signupVisible:false,
      visible:false
    })
    window.location = "/login?hide-signup-modal=true";
  };

  handleSignup = () => {
    this.setState({
      signupVisible:false,
      visible:true
    })
  };
  hideChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: false });
  };
  onChangePassword = value => {
    value.currentPassword = this.state.password;
    const { password, passwordVerification } = value;
    if (
        !validatePassword(password) ||
        !validatePassword(passwordVerification)
    ) {
      displayGenericError({
        message:
            "Your password must be have at least 8 characters with 1 uppercase and 1 lowercase"
      });
      return;
    }
    changePasswordInFirstTime(value)
        .then(() => {
          getCurrentCustomer()
              .then(customer => {
                displaySuccessMessage("You have change password success!")
                window.location = "/";
              })
              .catch(displayGenericError);
        })
        .catch(displayGenericError);
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <div className="sign-up-wrapper">
          <div className="left-panel">
            <Link className={"back-link"} to="/login">
              {/*<Icon className="left-panel-back-icon" type="left" />
              Back to Home page*/}
            </Link>
            <div className="sign-up-form">
              <div className={"inner"}>
                <h3 className="headline"><b>Sign in to your account</b></h3>
                <Form onSubmit={this.handleSubmit} className="login-form">
                  <div className={"form-content"}>
                    <Form.Item
                        validateStatus={this.state.isNoError ? "success" : "error"}
                        help={this.state.isNoError ? "" : this.state.errorMessage}>

                    </Form.Item>
                    <Form.Item label={"Email"}>
                      {getFieldDecorator("email", {
                        rules: [
                          {
                            required: true,
                            message: "Please enter your email!"
                          }
                        ]
                      })(<Input size="large" name="email" value={this.state.email} onChange={()=>{
                        this.setState({
                          isNoError: true,
                          errorMessage:''
                        })
                      }} />)}
                    </Form.Item>

                    <Form.Item label={"Password"}>
                      {getFieldDecorator("password", {
                        rules: [
                          {
                            required: true,
                            message: "Please enter your password!"
                          }
                        ]
                      })(
                        <Password
                          size={"large"}
                          type="password"
                          onChange={this.handlePasswordValue}
                        />
                      )}
                    </Form.Item>
                  </div>

                  <Link
                    className={"forgot-password-link"}
                    to={"/forgot-password"}
                  >
                    Forgot Password?
                  </Link>

                  <Button
                    htmlType="submit"
                    type="primary"
                    className="sign-up-button"
                  >
                    Log In
                  </Button>
                </Form>
               
                <div className={"direct-login-link"}>
                  Don't have an account?
                  <span className={"signup-link"} onClick={this.handleOpenSignupModal}>Sign Up</span>
                </div>
              </div>
            </div>
          </div>
          {/*
          <div className="right-panel">
            <div className="bp-page-body">
              <div> <ClientTransferCalculatorSignUp onChange={() => {

              }} /></div>
            </div>
            <div className="container-info">
            <div className="text-info">
              <Text className="text-primary">
                <div>Hi,</div>
                <div>
                  Welcome to Brdgx
                </div>
              </Text>
              <h3 className={"describe"}>
                We transfer money across the world <br /> quickly, simply and
                securely.
              </h3>
            </div>
            <Text className="text-copy-right">
              All rights reserved. Copyright 2020 Brdgx.
            </Text>
          </div>
          </div>
            */}
        </div>
        <OkModal
          message="Please verify your email address."
          visible={this.state.visible}
          handleOk={this.handleOk}
          title="Confirmation email is sent"
        />
        <SignUpModal
          visible={this.state.signupVisible}
          handleOk={this.handleSignup}
          onCancel={this.handleCloseSignupModal}
          title="Sign Up"
        />
        <Modal
          wrapClassName="otp-sign-in"
          visible={this.state.otpVisible}
          onCancel={() => this.setState({ otpVisible: false })}
          footer={null}
        >
       
          {(this.state.customer.loginStatus === "PHONE_NUMBER_REQUIRED" || this.state.customer.loginStatus === "NO_LOGIN" ) ? (
            <EnterPhoneNumberLayout
              proceedHandler={this.handleSubmitPhoneNumber}
            />
          ) : (
            <EnterOTPLayout
              customer={this.state.customer}
              verifyOTP={this.handleSubmitOTP}
              generateAuthyQRCode={this.generateAuthyQRCode}
              token={this.token}
            />
          )}
        </Modal>
        <Modal  visible={this.state.qrCodeVisible} onOk={this.closeQRModal} onCancel={this.closeQRModal}>
          <div style={{ height: "auto", margin: "0 auto", maxWidth: 512, width: "100%" , marginTop:"3px"}}>
            <QRCode
                size={512}
                style={{ height: "auto", maxWidth: "100%", width: "100%" ,  marginTop:"3px"}}
                value={this.state.qrValue}
                viewBox={`0 0 512 512`}
            />
          </div>
          <div className="otp-input-section">
            <span>(Please open TOTP app like Authy, Google Authenticator,...and capture QR code Then input opt number bellow)  </span>
            <OtpInput
                shouldAutoFocus={true}
                numInputs={6}
                isInputNum={true}
                containerStyle={{ height: "100%" }}
                value={this.state.otp}
                onChange={otp => this.setState({ otp },()=>{
                  if(this.state.otp.length === 6){
                    this.verifyFactor()
                  }
                })}
            />
          </div>
        </Modal>
        <ChangePasswordModal
            visible={this.state.showChangePasswordModal}
            onOk={this.onChangePassword}
            hiddenCurrentPasword={true}
            onCancel={this.hideChangePasswordModal}
        />
      </>
    );
  }

  handlePasswordValue = value => {
    this.setState({
      isNoError: true,
      errorMessage:'',
      password: value.target.value
    })
    this.props.form.setFieldsValue({ password: value });
  };
}
